//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Creates a new recipe folder for the user.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function create(dto: Types.CreateOrUpdateRecipeFolderDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeFolderDto> {
    let url_ = getBaseUrl() + "/api/recipe-folder";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateOrUpdateRecipeFolderDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.RecipeFolderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeFolderDto(resultData200);
        return Promise.resolve<Types.RecipeFolderDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeFolderDto>(null as any);
}

/**
 * Gets all recipe folders for the user.
 * @return List with all folders of the user.
 */
export function getRecipeFoldersForUser(config?: AxiosRequestConfig | undefined): Promise<Types.RecipeFolderDto[]> {
    let url_ = getBaseUrl() + "/api/recipe-folder";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRecipeFoldersForUser,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetRecipeFoldersForUser?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRecipeFoldersForUser(_response);
    });
}

function processGetRecipeFoldersForUser(response: AxiosResponse): Promise<Types.RecipeFolderDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initRecipeFolderDto(item)
              );
            }
        return Promise.resolve<Types.RecipeFolderDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeFolderDto[]>(null as any);
}

/**
 * Creates a new recipe folder for the user.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function createCalculationTemplate(dto: Types.CreateOrUpdateRecipeFolderDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeFolderDto> {
    let url_ = getBaseUrl() + "/api/recipe-folder/calculation-template";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateOrUpdateRecipeFolderDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateCalculationTemplate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateCalculationTemplate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateCalculationTemplate(_response);
    });
}

function processCreateCalculationTemplate(response: AxiosResponse): Promise<Types.RecipeFolderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeFolderDto(resultData200);
        return Promise.resolve<Types.RecipeFolderDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeFolderDto>(null as any);
}

/**
 * Updates recipe folder for the user.
 * @param recipeFolderId Id of the folder to update.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function update(recipeFolderId: number, dto: Types.CreateOrUpdateRecipeFolderDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeFolderDto> {
    let url_ = getBaseUrl() + "/api/recipe-folder/{recipeFolderId}";
    if (recipeFolderId === undefined || recipeFolderId === null)
      throw new Error("The parameter 'recipeFolderId' must be defined.");
    url_ = url_.replace("{recipeFolderId}", encodeURIComponent("" + recipeFolderId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateOrUpdateRecipeFolderDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdate,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdate(_response);
    });
}

function processUpdate(response: AxiosResponse): Promise<Types.RecipeFolderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeFolderDto(resultData200);
        return Promise.resolve<Types.RecipeFolderDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeFolderDto>(null as any);
}

/**
 * Deletes recipe folder for the user.
 * @return List with all folders of the user.
 */
export function remove(recipeFolderId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe-folder/{recipeFolderId}";
    if (recipeFolderId === undefined || recipeFolderId === null)
      throw new Error("The parameter 'recipeFolderId' must be defined.");
    url_ = url_.replace("{recipeFolderId}", encodeURIComponent("" + recipeFolderId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemove,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemove?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemove(_response);
    });
}

function processRemove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets recipe folders of the user.
 */
export function getRecipeFolderByPublicId(folderPublicId: string, config?: AxiosRequestConfig | undefined): Promise<Types.RecipePublicFolderDto> {
    let url_ = getBaseUrl() + "/api/recipe-folder/{folderPublicId}";
    if (folderPublicId === undefined || folderPublicId === null)
      throw new Error("The parameter 'folderPublicId' must be defined.");
    url_ = url_.replace("{folderPublicId}", encodeURIComponent("" + folderPublicId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRecipeFolderByPublicId,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetRecipeFolderByPublicId?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRecipeFolderByPublicId(_response);
    });
}

function processGetRecipeFolderByPublicId(response: AxiosResponse): Promise<Types.RecipePublicFolderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipePublicFolderDto(resultData200);
        return Promise.resolve<Types.RecipePublicFolderDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipePublicFolderDto>(null as any);
}

/**
 * Updates recipes sorting in the folder.
 * @param recipeFolderId Id of the folder to update.
 * @param sortingType (optional) Type of recipes sorting in the RecipeFolder
 * @param sortingDirection (optional) Direction of recipes sorting in the RecipeFolder
 */
export function updateSorting(recipeFolderId: number, sortingType?: Types.SortingType | undefined, sortingDirection?: Types.SortDirection | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe-folder/{recipeFolderId}/recipes-sorting?";
    if (recipeFolderId === undefined || recipeFolderId === null)
      throw new Error("The parameter 'recipeFolderId' must be defined.");
    url_ = url_.replace("{recipeFolderId}", encodeURIComponent("" + recipeFolderId));
    if (sortingType === null)
        throw new Error("The parameter 'sortingType' cannot be null.");
    else if (sortingType !== undefined)
        url_ += "sortingType=" + encodeURIComponent("" + sortingType) + "&";
    if (sortingDirection === null)
        throw new Error("The parameter 'sortingDirection' cannot be null.");
    else if (sortingDirection !== undefined)
        url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateSorting,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdateSorting?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateSorting(_response);
    });
}

function processUpdateSorting(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigGetRecipeFoldersForUser: Partial<AxiosRequestConfig> | null;
export function getGetRecipeFoldersForUserRequestConfig() {
  return _requestConfigGetRecipeFoldersForUser;
}
export function setGetRecipeFoldersForUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRecipeFoldersForUser = value;
}
export function patchGetRecipeFoldersForUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRecipeFoldersForUser = patch(_requestConfigGetRecipeFoldersForUser ?? {});
}

let _requestConfigCreateCalculationTemplate: Partial<AxiosRequestConfig> | null;
export function getCreateCalculationTemplateRequestConfig() {
  return _requestConfigCreateCalculationTemplate;
}
export function setCreateCalculationTemplateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateCalculationTemplate = value;
}
export function patchCreateCalculationTemplateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateCalculationTemplate = patch(_requestConfigCreateCalculationTemplate ?? {});
}

let _requestConfigUpdate: Partial<AxiosRequestConfig> | null;
export function getUpdateRequestConfig() {
  return _requestConfigUpdate;
}
export function setUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = value;
}
export function patchUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = patch(_requestConfigUpdate ?? {});
}

let _requestConfigRemove: Partial<AxiosRequestConfig> | null;
export function getRemoveRequestConfig() {
  return _requestConfigRemove;
}
export function setRemoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemove = value;
}
export function patchRemoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemove = patch(_requestConfigRemove ?? {});
}

let _requestConfigGetRecipeFolderByPublicId: Partial<AxiosRequestConfig> | null;
export function getGetRecipeFolderByPublicIdRequestConfig() {
  return _requestConfigGetRecipeFolderByPublicId;
}
export function setGetRecipeFolderByPublicIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRecipeFolderByPublicId = value;
}
export function patchGetRecipeFolderByPublicIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRecipeFolderByPublicId = patch(_requestConfigGetRecipeFolderByPublicId ?? {});
}

let _requestConfigUpdateSorting: Partial<AxiosRequestConfig> | null;
export function getUpdateSortingRequestConfig() {
  return _requestConfigUpdateSorting;
}
export function setUpdateSortingRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSorting = value;
}
export function patchUpdateSortingRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSorting = patch(_requestConfigUpdateSorting ?? {});
}